module.exports = {
      id: "linkedin-usage",
      viewBox: "0 0 48 48",
      url: __webpack_public_path__ + "svg-sprite.svg#linkedin",
      toString: function () {
        return this.url;
      }
    }